// GENERATED by scripts/fetch-bedrock-models.ts — do not edit by hand.
// Refresh: AWS_REGION=us-east-1 pnpm tsx scripts/fetch-bedrock-models.ts
export const GENERATED_BEDROCK_MODELS = [
  {
    id: 'openai.gpt-oss-120b-1:0',
    input: ['text'],
    output: ['text'],
    apis: { converse: true, chat: true, responses: true },
  },
  {
    id: 'openai.gpt-oss-20b-1:0',
    input: ['text'],
    output: ['text'],
    apis: { converse: true, chat: true, responses: true },
  },
  {
    id: 'us.anthropic.claude-sonnet-4-5-20250929-v1:0',
    input: ['text', 'image', 'document'],
    output: ['text'],
    apis: { converse: true, chat: false, responses: false },
  },
  {
    id: 'us.anthropic.claude-haiku-4-5-20251001-v1:0',
    input: ['text', 'image', 'document'],
    output: ['text'],
    apis: { converse: true, chat: false, responses: false },
  },
  {
    id: 'us.anthropic.claude-3-7-sonnet-20250219-v1:0',
    input: ['text', 'image', 'document'],
    output: ['text'],
    apis: { converse: true, chat: false, responses: false },
  },
  {
    id: 'us.anthropic.claude-3-5-sonnet-20241022-v2:0',
    input: ['text', 'image', 'document'],
    output: ['text'],
    apis: { converse: true, chat: false, responses: false },
  },
  {
    id: 'us.anthropic.claude-3-5-haiku-20241022-v1:0',
    input: ['text'],
    output: ['text'],
    apis: { converse: true, chat: false, responses: false },
  },
  {
    id: 'us.amazon.nova-pro-v1:0',
    input: ['text', 'image', 'document'],
    output: ['text'],
    apis: { converse: true, chat: false, responses: false },
  },
  {
    id: 'us.amazon.nova-lite-v1:0',
    input: ['text', 'image', 'document'],
    output: ['text'],
    apis: { converse: true, chat: false, responses: false },
  },
  {
    id: 'us.amazon.nova-micro-v1:0',
    input: ['text'],
    output: ['text'],
    apis: { converse: true, chat: false, responses: false },
  },
  {
    id: 'us.meta.llama3-3-70b-instruct-v1:0',
    input: ['text'],
    output: ['text'],
    apis: { converse: true, chat: false, responses: false },
  },
  {
    id: 'us.meta.llama4-maverick-17b-instruct-v1:0',
    input: ['text', 'image'],
    output: ['text'],
    apis: { converse: true, chat: false, responses: false },
  },
  {
    id: 'us.mistral.pixtral-large-2502-v1:0',
    input: ['text', 'image'],
    output: ['text'],
    apis: { converse: true, chat: false, responses: false },
  },
  {
    id: 'us.deepseek.r1-v1:0',
    input: ['text'],
    output: ['text'],
    apis: { converse: true, chat: false, responses: false },
  },
  {
    id: 'google.gemma-4-31b',
    input: ['text', 'image'],
    output: ['text'],
    apis: { converse: false, chat: true, responses: true },
  },
  {
    id: 'google.gemma-4-26b-a4b',
    input: ['text', 'image'],
    output: ['text'],
    apis: { converse: false, chat: true, responses: true },
  },
  {
    id: 'google.gemma-4-e2b',
    input: ['text', 'image'],
    output: ['text'],
    apis: { converse: false, chat: true, responses: true },
  },
] as const
